import { render, staticRenderFns } from "./PWAPrompt.vue?vue&type=template&id=1785b845&scoped=true"
import script from "./PWAPrompt.vue?vue&type=script&lang=js"
export * from "./PWAPrompt.vue?vue&type=script&lang=js"
import style0 from "./PWAPrompt.vue?vue&type=style&index=0&id=1785b845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785b845",
  null
  
)

export default component.exports